import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Modals from "../../../components/modal";
import { useShowReviews } from "./hooks";
import Review from "./review";

const ShowReviews = ({ event }) => {
  const {
    openReviewsList,
    toggleModal,
    reviews,
    isOpenModal,
    updateReviewStatus,
  } = useShowReviews(event.id);

  return (
    <div>
      <Tooltip title="Click to view Reviews" placement="bottom">
        <div
          className="action_review-schedule-event"
          onClick={() => {
            openReviewsList("event");
          }}
        >
          <i className="fa fa-user" aria-hidden="true"></i>
          <i className="fa fa-star-o user-icon" aria-hidden="true"></i>
        </div>
      </Tooltip>

      {isOpenModal ? (
        <Modals
          isOpenModal
          setIsOpenModal={toggleModal}
          message={
            <Review data={reviews} updateReviewStatus={updateReviewStatus} />
          }
          title="Reviews"
        />
      ) : null}
    </div>
  );
};

export default ShowReviews;
